import { SearchCriteriaSortFieldEnum } from '../../../api/mentions/enum/search-criteria-sort-field.enum';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';
import { ChartMetricsEnum } from '../../Reports/enums/chart-metrics.enum';

export enum ChartDataTypesEnum {
    ave,
    custom,
    dataConnector,
    domainAuthority,
    engagements,
    audienceReach, // impressions
    mediaType,
    prominence,
    recentActivity,
    region,
    sentiment,
    topSources,
    volume,
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ChartDataTypesToPermissionsMap = new Map<ChartDataTypesEnum, userPermissionsEnum[]>([
    [ChartDataTypesEnum.ave,             [ userPermissionsEnum.advancedMonitoring ]],
    [ChartDataTypesEnum.custom,          [ userPermissionsEnum.advancedMonitoring, userPermissionsEnum.socialIntelligence ]],
    [ChartDataTypesEnum.dataConnector,   [ userPermissionsEnum.advancedMonitoring, userPermissionsEnum.socialIntelligence ]],
    [ChartDataTypesEnum.domainAuthority, [ userPermissionsEnum.advancedMonitoring, userPermissionsEnum.socialIntelligence ]],
    [ChartDataTypesEnum.engagements,     [ userPermissionsEnum.socialIntelligence ]],
    [ChartDataTypesEnum.audienceReach,   [ userPermissionsEnum.advancedMonitoring, userPermissionsEnum.socialIntelligence ]],
    [ChartDataTypesEnum.mediaType,       [ userPermissionsEnum.advancedMonitoring, userPermissionsEnum.socialIntelligence ]],
    [ChartDataTypesEnum.prominence,      [ userPermissionsEnum.advancedMonitoring ]],
    [ChartDataTypesEnum.recentActivity,  [ userPermissionsEnum.advancedMonitoring, userPermissionsEnum.advancedTargeting ]],
    [ChartDataTypesEnum.region,          [ userPermissionsEnum.advancedMonitoring, userPermissionsEnum.socialIntelligence ]],
    [ChartDataTypesEnum.sentiment,       [ userPermissionsEnum.advancedMonitoring, userPermissionsEnum.socialIntelligence ]],
    [ChartDataTypesEnum.topSources,      [ userPermissionsEnum.advancedMonitoring, userPermissionsEnum.socialIntelligence ]],
    [ChartDataTypesEnum.volume,          [ userPermissionsEnum.advancedMonitoring, userPermissionsEnum.socialIntelligence ]],
]);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ChartDataTypesToChartMetricsMap = new Map<ChartDataTypesEnum, ChartMetricsEnum>([
    [ChartDataTypesEnum.ave, ChartMetricsEnum.ave],
    [ChartDataTypesEnum.custom, ChartMetricsEnum.custom],
    [ChartDataTypesEnum.domainAuthority, ChartMetricsEnum.domainAuthority],
    [ChartDataTypesEnum.engagements, ChartMetricsEnum.ENGAGEMENTS],
    [ChartDataTypesEnum.audienceReach, ChartMetricsEnum.IMPRESSIONS],
    [ChartDataTypesEnum.volume, ChartMetricsEnum.volumeOfMentions],
]);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ChartDataTypesToSearchCriteriaSortFieldMap = new Map<ChartDataTypesEnum, SearchCriteriaSortFieldEnum>([
    [ChartDataTypesEnum.ave, SearchCriteriaSortFieldEnum.ave],
    [ChartDataTypesEnum.custom, SearchCriteriaSortFieldEnum.custom],
    [ChartDataTypesEnum.domainAuthority, SearchCriteriaSortFieldEnum.domainAuthority],
    [ChartDataTypesEnum.audienceReach, SearchCriteriaSortFieldEnum.audience_reach],
]);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ChartMetricsToChartDataTypesMap = new Map<ChartMetricsEnum, ChartDataTypesEnum>([
    [ChartMetricsEnum.ave, ChartDataTypesEnum.ave],
    [ChartMetricsEnum.custom, ChartDataTypesEnum.custom ],
    [ChartMetricsEnum.domainAuthority, ChartDataTypesEnum.domainAuthority],
    [ChartMetricsEnum.ENGAGEMENTS, ChartDataTypesEnum.engagements ],
    [ChartMetricsEnum.IMPRESSIONS, ChartDataTypesEnum.audienceReach],
    [ChartMetricsEnum.volumeOfMentions, ChartDataTypesEnum.volume],
]);
